"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.is-integer");
require("core-js/modules/es6.number.constructor");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _devicereturn = require("@/api/devicereturn.js");
var _org = require("@/api/org");
var _device_salesorder = require("@/api/device_salesorder");
var _device = require("@/api/device");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultDeviceReturn = {
  sales_order_no: '',
  return_reason: '',
  directions: '',
  amount: '',
  quantity: '',
  receiving_dept_no: ''
};
var defaultDeviceShipment = {
  receive_status: null
};
var defaultDeviceApproval = {
  approval_status: null,
  remark: null
};
var defaultDeviceSalesOrder = {
  create_time: '',
  create_user_id: '',
  create_user_name: '',
  remark: '',
  approval_time: '',
  approval_user_id: '',
  approval_user_name: '',
  approval_remark: '',
  receiving_time: '',
  receiving_user_id: '',
  receiving_user_name: '',
  receiving_remark: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number(value * 1) && value * 1 !== 0) {
    callBack(new Error('请输入合法的数值'));
  } else {
    if (value * 1 < 0) {
      callBack(new Error('金额不能小于0'));
    } else {
      callBack();
    }
  }
};
var checkNumber1 = function checkNumber1(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数量不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: true,
      tableData: [],
      devicereturn: defaultDeviceReturn,
      deviceshipment: defaultDeviceShipment,
      deviceapproval: defaultDeviceApproval,
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      viewSaleDialog: false,
      shipmentDialog: false,
      dialogType: 'new',
      dialogTransformLoading: false,
      transformData: {
        results: []
      },
      dialogTransformLoading1: false,
      transformData1: {
        results: []
      },
      receiving_dept_name: '',
      receiving_time: '',
      receiving_person: '',
      number: '',
      rule1: {
        sales_order_no: [{
          required: true,
          message: '请输入销售单号',
          trigger: 'blur'
        }],
        return_reason: [{
          required: true,
          message: '请输入退货原因',
          trigger: 'blur'
        }],
        directions: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入退款金额',
          trigger: 'blur'
        }, {
          validator: checkNumber
        }],
        quantity: [{
          required: true,
          message: '请输入退货数量',
          trigger: 'blur'
        }, {
          validator: checkNumber1
        }],
        receiving_medical_no: [{
          required: true,
          message: '请输入收货医疗机构编号',
          trigger: 'blur'
        }]
      },
      rule2: {
        receive_status: [{
          required: true,
          message: '请选择确认收货状态',
          trigger: 'change'
        }]
      },
      rule3: {
        approval_status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '待确认收货'
      }, {
        value: 2,
        label: '待审核'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成退款'
      }],
      statusOptions1: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '待发货'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成'
      }],
      typeOptions: [{
        value: 1,
        label: '已收货'
      }, {
        value: 2,
        label: '未收货'
      }],
      typeOptions1: [{
        value: 2,
        label: '已收货'
      }, {
        value: 3,
        label: '未收货'
      }],
      approvalOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      attrOptions: [{
        value: 1,
        label: '购买'
      }, {
        value: 2,
        label: '赠送'
      }, {
        value: 3,
        label: '试用机'
      }, {
        value: 4,
        label: '其它'
      }],
      listQuery: {
        page: 1,
        page_size: 10
      },
      orgList: [],
      devicesalesorder: defaultDeviceSalesOrder,
      dept_name: '新汉方',
      dept_no: 'DZ0001',
      tableText: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      var _this = this;
      this.devicereturn = Object.assign({}, defaultDeviceReturn);
      this.devicereturn.receiving_dept_no = this.dept_no;
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs['Form'].clearValidate();
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _devicereturn.getDeviceReturn)(this.listQuery).then(function (response) {
        if (response.data) {
          _this2.tableData = response.data;
          console.log(_this2.tableData);
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      this.devicereturn = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
      this.getName();
    },
    handleDelete: function handleDelete(scope) {
      var _this4 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _devicereturn.deleteDeviceReturn)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this4.getList();
              _this4.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleView: function handleView(scope) {
      this.transformData.results.length = 0;
      this.viewDialog = true;
      this.dialogTransformLoading = true;
      this.devicereturn = Object.assign({}, scope.row);
      this.transformData.results.push(this.devicereturn);
      this.dialogTransformLoading = false;
    },
    handleViewSale: function () {
      var _handleViewSale = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(scope) {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.transformData1.results = [];
              this.devicesalesorder = Object.assign({}, defaultDeviceSalesOrder);
              this.viewSaleDialog = true;
              this.dialogTransformLoading1 = true;
              _context2.next = 6;
              return (0, _device_salesorder.getDeviceSalesOrderAll)({
                sales_order_no: scope.row.sales_order_no
              }).then(function (res) {
                var arr = res.data.results;
                console.log(arr);
                for (var i = 0; i < res.data.count; i++) {
                  if (arr[i].sales_order_no === scope.row.sales_order_no) {
                    _this5.transformData1.results.push(arr[i]);
                    _this5.devicesalesorder.create_time = arr[i].create_time;
                    _this5.devicesalesorder.create_user_id = arr[i].create_user_id;
                    _this5.devicesalesorder.create_user_name = arr[i].create_user_name;
                    _this5.devicesalesorder.remark = arr[i].remark;
                    _this5.devicesalesorder.approval_time = arr[i].approval_time;
                    _this5.devicesalesorder.approval_user_id = arr[i].approval_user_id;
                    _this5.devicesalesorder.approval_user_name = arr[i].approval_user_name;
                    _this5.devicesalesorder.approval_remark = arr[i].approval_remark;
                    _this5.devicesalesorder.receiving_time = arr[i].receiving_time;
                    _this5.devicesalesorder.receiving_user_id = arr[i].receiving_user_id;
                    _this5.devicesalesorder.receiving_user_name = arr[i].receiving_user_name;
                    _this5.devicesalesorder.receiving_remark = arr[i].receiving_remark;
                  }
                }
              });
            case 6:
              if (this.transformData1.results.length === 0) {
                this.tableText = '暂无数据';
              } else {
                this.tableText = '';
              }
              console.log(this.transformData1);
              this.dialogTransformLoading1 = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleViewSale(_x) {
        return _handleViewSale.apply(this, arguments);
      }
      return handleViewSale;
    }(),
    handleApproval: function () {
      var _handleApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(scope) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.devicereturn = Object.assign({}, scope.row);
              this.deviceapproval = Object.assign({}, defaultDeviceApproval);
              _context3.next = 4;
              return (0, _user.getUser)(this.devicereturn.create_by).then(function (response) {
                _this6.devicereturn.create_by = response.data.name;
              });
            case 4:
              this.approvalDialog = true;
              this.$nextTick(function () {
                _this6.$refs['approvalForm'].clearValidate();
              });
              this.getName();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleApproval(_x2) {
        return _handleApproval.apply(this, arguments);
      }
      return handleApproval;
    }(),
    handleShipment: function handleShipment(scope) {
      var _this7 = this;
      this.devicereturn = Object.assign({}, scope.row);
      this.deviceshipment = Object.assign({}, defaultDeviceShipment);
      this.shipmentDialog = true;
      this.$nextTick(function () {
        _this7.$refs['shipmentForm'].clearValidate();
      });
      this.getName();
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _devicereturn.updateDeviceReturn)(_this8.devicereturn.id, _this8.devicereturn).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _devicereturn.createDeviceReturn)(_this8.devicereturn).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirm(_x3) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    getName: function getName() {
      var _this9 = this;
      console.log(this.devicereturn.receiving_dept_no);
      this.listQuery.dept_no = this.devicereturn.receiving_dept_no;
      (0, _org.getOrgList)(this.listQuery).then(function (response) {
        if (response.data) {
          console.log(response.data);
          _this9.receiving_dept_name = response.data[0].name;
        } else {
          _this9.receiving_dept_name = '';
        }
      });
      console.log(this.receiving_dept_name);
    },
    getSaleOrder: function getSaleOrder() {
      var _this10 = this;
      if (this.devicereturn.sales_order_no) {
        (0, _device_salesorder.getDeviceSalesOrderAll)({
          sales_order_no: this.devicereturn.sales_order_no
        }).then(function (response) {
          if (response.data.count === 1) {
            _this10.devicereturn.amount = response.data.results[0].amount;
            _this10.devicereturn.quantity = response.data.results[0].quantity;
            // this.devicereturn.receiving_dept_no = response.data.results[0].receiving_medical_no
          } else {
            _this10.devicereturn.amount = '';
            _this10.devicereturn.quantity = '';
            // this.devicereturn.receiving_dept_no = ''
          }
        });
      } else {
        this.devicereturn.amount = '';
        this.devicereturn.quantity = '';
        // this.devicereturn.receiving_dept_no = ''
      }
      console.log(this.devicereturn.amount);
    },
    confirmApproval: function () {
      var _confirmApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this11 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _devicereturn.approvalDeviceReturn)(_this11.devicereturn.id, _this11.deviceapproval).then(function (res) {
                    if (_this11.deviceapproval.approval_status === 1) {
                      _this11.getList();
                      _this11.approvalDialog = false;
                      _this11.$message({
                        message: '审核通过',
                        type: 'success'
                      });
                    } else if (_this11.deviceapproval.approval_status === 2) {
                      _this11.getList();
                      _this11.approvalDialog = false;
                      _this11.$message({
                        message: '审核拒绝',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirmApproval(_x4) {
        return _confirmApproval.apply(this, arguments);
      }
      return confirmApproval;
    }(),
    confirmShipment: function () {
      var _confirmShipment = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this12 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _devicereturn.receiptDeviceReturn)(_this12.devicereturn.id, _this12.deviceshipment).then(function (res) {
                    // this.getList()
                    // this.shipmentDialog = false
                    // this.$message({
                    //   message: '已收货',
                    //   type: 'success'
                    // })
                    if (_this12.deviceshipment.receive_status === 1) {
                      _this12.getList();
                      _this12.shipmentDialog = false;
                      _this12.$message({
                        message: '已收货',
                        type: 'success'
                      });
                    } else if (_this12.deviceshipment.receive_status === 2) {
                      _this12.getList();
                      _this12.shipmentDialog = false;
                      _this12.$message({
                        message: '未收货',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmShipment(_x5) {
        return _confirmShipment.apply(this, arguments);
      }
      return confirmShipment;
    }()
  }
};